import { createAction } from 'redux-actions';
export var fetchArtAuthor = createAction('ART_BRANDED_POPUP.FETCH_ART_AUTHOR', function (payload) { return payload; });
export var fetchArtAuthorSuccess = createAction('ART_BRANDED_POPUP.FETCH_ART_AUTHOR_SUCCESS', function (payload) { return payload; });
//# sourceMappingURL=actions.js.map